import { validatePassword } from '@auth/common/util';

export const validateOrgName = (n: string): boolean => {
  const nameFormat = /^[\d ',.a-z-]+$/i;
  return nameFormat.test(n);
};

export const validatePasswordError = (password: string) => {
  if (!password) {
    return 'Enter a password to continue';
  }
  if (password.startsWith(' ') || password.endsWith(' ')) {
    return 'Passwords can’t start or end with a space';
  }
  const response = validatePassword(password);
  if (response.error) {
    return 'Password does not meet minimum requirements';
  }
  return '';
};

export const validateConfirmPasswordError = (confirmPassword: string, password: string) => {
  if (!confirmPassword) {
    return 'Confirm the password to continue';
  }
  if (confirmPassword !== password && password !== '') {
    return 'Passwords do not match';
  }
  return '';
};
